<template>
  <div class="home">
    <!-- Start Main Banner Section  -->
    <MainBannerBlock
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.MainBannerBlock.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(
          this.$store.state.current_content,
          'secondary.MainBannerBlock.data'
        )
      "
    />

    <!-- End Main Banner Section -->

    <!-- Start News Section  -->
    <NewsBlock
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.NewsBlock.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.NewsBlock')
      "
    />
    <!-- End News Section  -->

    <!-- Start Products Section  -->
    <ProductsSlider
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.ProductsSlider.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.ProductsSlider')
      "
    />
    <!-- End Product Section -->

    <!-- Start More Ways Section -->
    <MoreWaysForBanking
      v-if="_.size(this.$store.state.current_content)"
      class="more-ways-business"
    />
    <!-- End More Ways Section -->

    <!-- Start of Currencies Mobile Section  -->
    <section class="container currencies-mob">
      <Currencies
        v-if="
          _.get(
            this.$store.state.current_content,
            'secondary.smart_block.conf.currencies'
          ) == 1
        "
      />
    </section>
    <!-- End of Currencies Mobile Section  -->

    <!-- Start Offer Slider Section  -->
    <TodaysOffer
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.TodaysOffer.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.TodaysOffer')
      "
    />
    <!-- End Offer Slider Section  -->
    <section
      class="container"
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.smart_block.conf.enabled'
        ) == 1
      "
    >
      <div class="curAndBranches mt-144 flex-box">
        <Currencies
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.smart_block.conf.currencies'
            ) == 1
          "
        />
        <Branches
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.smart_block.conf.branches'
            ) == 1
          "
        />
      </div>
    </section>
    <!-- End Calculator Section -->

    <!-- Start Get it Today -->
    <BusinessBanner
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.business_banner.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(
          this.$store.state.current_content,
          'secondary.business_banner.data'
        )
      "
    />
  </div>
</template>

<script>
// @ is an alias to /src\

import MainBannerBlock from "@/components/MainBannerBlock";
import ProductsSlider from "@/components/ProductsSlider";
import NewsBlock from "@/components/NewsBlock";
import TodaysOffer from "@/components/TodaysOffer";
import Currencies from "@/components/Currencies";
import Branches from "@/components/Branches";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import BusinessBanner from "@/components/BusinessBanner";
import CalculatorLoans from "@/components/CalculatorLoans";

export default {
  name: "Home",
  components: {
    MainBannerBlock,
    ProductsSlider,
    NewsBlock,
    TodaysOffer,
    Currencies,
    Branches,
    MoreWaysForBanking,
    BusinessBanner,
    CalculatorLoans,
  },
};
</script>

<style scoped>
.more-ways-business.mt-144 {
  margin-top: 0;
  background: rgba(188, 190, 192, 0.2);
  padding-bottom: 89px;
}
@media (max-width: 1365px) {
  .more-ways-business.mt-144 {
    padding-bottom: 55px;
  }
}
</style>
